import React from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../i18n/index.jsx';
import { formatPrice, formatQuantity, categoryName, placeName } from '../format.js';

export default function ListingCard({ listing, showSeller = true }) {
  const { t, lang } = useI18n();
  const qty = formatQuantity(listing, lang);
  const place = placeName(listing.seller, t);
  return (
    <Link to={`/marketplace/${listing.id}`} className="listing-card">
      <div className="listing-card-photo">
        {listing.coverUrl ? <img src={listing.coverUrl} alt="" loading="lazy" decoding="async" /> : <span className="listing-card-nophoto">{t('listing.noPhoto')}</span>}
      </div>
      <div className="listing-card-body">
        <p className="listing-card-cat">{categoryName(listing.category, lang)}{listing.featured && <span className="featured-badge">★</span>}</p>
        <h3 className="listing-card-title">{listing.title}</h3>
        <p className="listing-card-price">{formatPrice(listing, lang, t)}{qty && <span className="muted"> · {qty}</span>}</p>
        {showSeller && <p className="listing-card-seller muted">{listing.seller.companyName}{place && ` · ${place}`}</p>}
      </div>
    </Link>
  );
}
